import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{staticClass:"ma-0 pa-0",attrs:{"outlined":"","dense":"","hide-details":"","clearable":"","label":_vm.label},on:{"blur":_vm.callBackData},model:{value:(_vm.defaultWord),callback:function ($$v) {_vm.defaultWord=$$v},expression:"defaultWord"}})}
var staticRenderFns = []

export { render, staticRenderFns }